export  default {
  setNoteTypes(state, payload){
    state.noteTypes = payload;
  }
};